

const Loading=()=>{

    return <>
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-sm">
    <div className="flex flex-col items-center gap-4 rounded-2xl bg-white px-10 py-8 shadow-2xl">
      
      {/* Spinner */}
      <div className="relative h-14 w-14">
        <div className="absolute inset-0 rounded-full border-4 border-gray-200" />

        <div className="absolute inset-0 animate-spin rounded-full border-4 border-transparent border-t-primary border-r-primary" />
      </div>

      {/* Text */}
      <div className="text-center">
        <p className="text-lg font-semibold text-gray-800">
          جاري التحميل...
        </p>

        <p className="mt-1 text-sm text-gray-500">
          الرجاء الانتظار حتى يتم التحميل
        </p>
      </div>
    </div>
  </div>
    </>
}

export default Loading;